import { render, staticRenderFns } from "./paperScore.vue?vue&type=template&id=3449207b&scoped=true&"
import script from "./paperScore.vue?vue&type=script&lang=js&"
export * from "./paperScore.vue?vue&type=script&lang=js&"
import style0 from "./paperScore.vue?vue&type=style&index=0&id=3449207b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3449207b",
  null
  
)

export default component.exports